<template>
  <canvas width="100%" height="450"></canvas>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    opened: {
      type: Array,
      default: () => []
    },
    clicked: {
      type: Array,
      default: () => []
    },
    bounced: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: "rgba(20,220,120,0.2)"
    }
  },
  mounted() {
    this.createChart();
  },
  methods: {
    createChart() {
      if (!this.$el) return;
      
      const ctx = this.$el.getContext("2d");
      if (!ctx) return;
      
      const chartData = {
        datasets: [
          {
            label: "Opened",
            data: this.opened || [],
            fill: false,
            borderColor: "#1abc9c",
            borderWidth: 1
          },
          {
            label: "Clicked",
            data: this.clicked || [],
            fill: false,
            borderColor: "#2980b9",
            borderWidth: 1
          },
          {
            label: "Bounced",
            data: this.bounced || [],
            fill: false,
            borderColor: "#e67e22",
            borderWidth: 1
          }
        ],
        labels: this.labels || []
      };

      new Chart(ctx, {
        type: "line",
        data: chartData,
        options: {
          maintainAspectRatio: false,
          responsive: true,
          title: {
            display: true,
            position: "top"
          },
          tooltips: {
            enabled: true
          },
          cutoutPercentage: 40,
          responsive: true,
          animation: {
            animateScale: true,
            animateRotate: true
          },
          legend: {
            display: false,
            position: "top",
            fontSize: 16,
            labels: {
              paddingTop: 0,
              marginBottom: 10
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              }
            }]
          }
        }
      });
    }
  },
  watch: {
    labels: {
      handler() {
        this.createChart();
      },
      deep: true
    },
    opened: {
      handler() {
        this.createChart();
      },
      deep: true
    },
    clicked: {
      handler() {
        this.createChart();
      },
      deep: true
    },
    bounced: {
      handler() {
        this.createChart();
      },
      deep: true
    }
  }
};
</script>